import { Text, TextSkeleton } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { formatDistanceToNow } from "date-fns";

import { useWorkerProfilePicture } from "../Agents/api/useWorkerProfilePicture";
import { WorkerAvatar } from "../redesign/components/WorkerAvatar";
import { useGetWorkerPublicProfile } from "../redesign/WorkWithFriends/hooks";
import { type NewsFeedItemComment } from "./types";

export interface NewsFeedItemCommentItemProps {
  comment: NewsFeedItemComment;
}

export function NewsFeedItemCommentItem(props: NewsFeedItemCommentItemProps) {
  const { comment } = props;

  const { data: workerPicture, isInitialLoading: isLoadingWorkerPicture } = useWorkerProfilePicture(
    comment.workerId,
    {
      useErrorBoundary: false,
      retry: 0,
    }
  );

  const workerData = useGetWorkerPublicProfile(comment.workerId, { useErrorBoundary: false });

  return (
    <Stack direction="row" width="100%" spacing={3}>
      <WorkerAvatar
        size="small"
        profilePictureUrl={workerPicture?.distribution_url}
        isLoading={isLoadingWorkerPicture}
      />
      <Stack>
        {workerData.isLoading && <TextSkeleton variant="body2" />}
        {workerData.isSuccess && (
          <Text variant="body2" color={(theme) => theme.palette.text.secondary}>
            {workerData.data.attributes.firstName}
          </Text>
        )}
        <Text sx={{ overflowWrap: "anywhere" }}>{comment.content}</Text>
        <Text variant="caption" color={(theme) => theme.palette.text.tertiary}>
          {formatDistanceToNow(new Date(comment.createdAt))} ago
        </Text>
      </Stack>
    </Stack>
  );
}
